export default __webpack_public_path__ + "static/media/default.3be4abbae173ae35f3ad66e977434298.png";